import Vue from 'vue'
import VueI18n from 'vue-i18n'
import localeZH from 'element-ui/lib/locale/lang/zh-CN'; 
import localeEN from 'element-ui/lib/locale/lang/en'; 

Vue.use(VueI18n)

function loadLocaleMessages() {
  const locales = require.context('../locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })
  return messages
}

function getDefaultLanguage() {
  const storedLanguage = localStorage.getItem('language');
  if (storedLanguage) return storedLanguage;

  const browserLanguage = navigator.language.toLowerCase();
  return browserLanguage.startsWith('zh-cn') ? 'zh-cn' : 'en';
}

const defaultLanguage = getDefaultLanguage();
const i18n = new VueI18n({
  locale: defaultLanguage,
  fallbackLocale: 'en',
  messages: loadLocaleMessages()
});

const currentLocale = defaultLanguage === 'zh-cn' ? localeZH : localeEN

export { i18n, currentLocale };